__turbopack_context__.v({
  "active": "twoColTimelineScroll-module-scss-module__BVE0PG__active",
  "allignTop": "twoColTimelineScroll-module-scss-module__BVE0PG__allignTop",
  "containerStretch": "twoColTimelineScroll-module-scss-module__BVE0PG__containerStretch",
  "contentWrapper": "twoColTimelineScroll-module-scss-module__BVE0PG__contentWrapper",
  "cta": "twoColTimelineScroll-module-scss-module__BVE0PG__cta",
  "halfWidth": "twoColTimelineScroll-module-scss-module__BVE0PG__halfWidth",
  "headline": "twoColTimelineScroll-module-scss-module__BVE0PG__headline",
  "image": "twoColTimelineScroll-module-scss-module__BVE0PG__image",
  "imageContainer": "twoColTimelineScroll-module-scss-module__BVE0PG__imageContainer",
  "imageWrapper": "twoColTimelineScroll-module-scss-module__BVE0PG__imageWrapper",
  "largeSpacer": "twoColTimelineScroll-module-scss-module__BVE0PG__largeSpacer",
  "minHeight": "twoColTimelineScroll-module-scss-module__BVE0PG__minHeight",
  "right": "twoColTimelineScroll-module-scss-module__BVE0PG__right",
  "spacer": "twoColTimelineScroll-module-scss-module__BVE0PG__spacer",
  "textContent": "twoColTimelineScroll-module-scss-module__BVE0PG__textContent",
  "textContentSpotlight": "twoColTimelineScroll-module-scss-module__BVE0PG__textContentSpotlight",
  "textDescription": "twoColTimelineScroll-module-scss-module__BVE0PG__textDescription",
  "textHeadline": "twoColTimelineScroll-module-scss-module__BVE0PG__textHeadline",
  "timeLineFixed": "twoColTimelineScroll-module-scss-module__BVE0PG__timeLineFixed",
  "timeline": "twoColTimelineScroll-module-scss-module__BVE0PG__timeline",
});
